import { useCallback, useState } from 'react';
import CourseThumbnailCropper from './CourseThumbnailCropper';
import { isImageFile } from '../../utils/courseThumbnailCrop';

const useCourseThumbnailCrop = ({ onCropped, onInvalidFile }) => {
  const [cropState, setCropState] = useState({
    open: false,
    src: null,
    fileName: '',
  });

  const closeCropper = useCallback(() => {
    setCropState({ open: false, src: null, fileName: '' });
  }, []);

  const handleThumbnailFileSelect = useCallback((e) => {
    const file = e.target.files?.[0];
    e.target.value = '';

    if (!file) return;

    if (!isImageFile(file)) {
      onInvalidFile?.('Please upload only image files (JPG, PNG, GIF, WebP)');
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      setCropState({
        open: true,
        src: event.target.result,
        fileName: file.name,
      });
    };
    reader.readAsDataURL(file);
  }, [onInvalidFile]);

  const handleCropConfirm = useCallback((file) => {
    onCropped?.(file);
    closeCropper();
  }, [closeCropper, onCropped]);

  const cropperModal = (
    <CourseThumbnailCropper
      open={cropState.open}
      imageSrc={cropState.src}
      fileName={cropState.fileName}
      onCancel={closeCropper}
      onConfirm={handleCropConfirm}
    />
  );

  return {
    cropperModal,
    handleThumbnailFileSelect,
  };
};

export default useCourseThumbnailCrop;
